import React from 'react'
import TimetoastTemporal from '../base/timetoast_temporal'
import TimetoastDateFormatter from '../utils/timetoast_date_formatter'

type TimeProps = {
  color?: string | null
  dateTime?: string | null
}

const Time: React.FC<TimeProps> = ({ dateTime, color }) => {
  if (dateTime) {
    let text: string | null = null
    try {
      // Note: If date can't be parsed, e.g. out of range, this will throw an error
      const timetoastTemporal = TimetoastTemporal.parse(dateTime)
      text = TimetoastDateFormatter.humanDate(timetoastTemporal)
    } catch (e) {
      console.error('Time.tsx', e)
      text = 'Invalid date'
    }

    const style = color ? { color } : {}

    return (
      <time dateTime={dateTime} className="time" style={style}>
        {text}
      </time>
    )
  }

  return null
}

export default Time
